import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { showError } from "../constants/toasts";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  membersData: any;
  setMembersData: any;
  setSelectedArray?: any;
  selectedArray?: any;
  cancellationRefundApi: any;
  cancellationId: string;
}

export default function RefundModal({
  open,
  onClose,
  setOpen,
  membersData,
  setMembersData,
  selectedArray,
  setSelectedArray,
  cancellationRefundApi,
  cancellationId,
}: AddCategoryModalProps) {
  const navigate = useNavigate();

  const formatItem = (item: any) => ({
    userId: item.payerUserId,
    amount: item.actualPaid,
  });

  const handleAmountChange = (index: number, value: string) => {
    setMembersData((prev: any) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        actualPaid: Number(value) || 0,
      };

      setMembersData((sel: any) =>
        sel?.map((s: any) =>
          s?.userId === updated[index]?.payerUserId
            ? formatItem(updated[index])
            : s
        )
      );

      return updated;
    });
  };

  const handleSingleCheck = (item: any, checked: boolean) => {
    if (checked) {
      setSelectedArray((prev: any) => [...prev, formatItem(item)]);
    } else {
      setSelectedArray((prev: any) =>
        prev.filter((i: any) => i.userId !== item.payerUserId)
      );
    }
  };

  // Handle "All" checkbox
  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedArray(membersData?.map((m: any) => formatItem(m)));
    } else {
      setSelectedArray([]);
    }
  };

  const allChecked =
    selectedArray?.length > 0 && selectedArray?.length === membersData?.length;

  return (
    <Modal className="modal refund_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Initiate Refund</h2>
            <div role="button" tabIndex={0} className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            {
              membersData?.length ? <div className="control_group refund_sc">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={allChecked}
                      indeterminate={
                        selectedArray?.length > 0 &&
                        selectedArray?.length < membersData?.length
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  }
                  label="All"
                />

                {membersData?.length
                  ? membersData?.map((item: any, index: number) => (
                    <FormControlLabel
                      key={item?.bookingId}
                      control={
                        <Checkbox
                          checked={
                            !!selectedArray?.find(
                              (s: any) => s?.userId === item?.payerUserId
                            )
                          }
                          onChange={(e) =>
                            handleSingleCheck(item, e.target.checked)
                          }
                        />
                      }
                      label={
                        <>
                          <p>{item?.name || "-"}</p>
                          <TextField
                            fullWidth
                            hiddenLabel
                            inputProps={{ maxLength: 10 }}
                            placeholder="Enter Amount"
                            value={item?.actualPaid}
                            onChange={(e) =>
                              handleAmountChange(index, e.target.value)
                            }
                          />
                        </>
                      }
                    />
                  ))
                  : null}
              </div> : <div style={{ textAlign: "center" }}><p style={{ color: "white" }}>No Users Found</p></div>
            }

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  if (!selectedArray?.length) {
                    showError("Please select member to refund");
                    return;
                  }

                  setOpen(false);
                  cancellationRefundApi(cancellationId, false);
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
